import { ApplicationStateSchema } from "state/ApplicationStateSchema";
import { z } from "zod";

export const ReviewApplicationStateSchema = ApplicationStateSchema;
export type ReviewApplicationState = z.infer<typeof ReviewApplicationStateSchema>;
